export enum SaveStatus {
  Error = 'failed',
  Success = 'success',
  ModifierUpdated = 'modifierUpdated',
}
